    // components/ProtectedRoute.js
    import React from 'react';
    import { Navigate, Outlet } from 'react-router-dom';

    function ProtectedRoute({ children }) {
      const isAuthenticated = localStorage.getItem('authToken'); // Check for token

      if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
      }

      return children ? children : <Outlet />;
    }

    export default ProtectedRoute;